export default "__VITE_ASSET__d835243b__"